<template>
  <Loader v-if="loader" />

  <prime-accordion class="box-operation-detail">
    <prime-accordion-tab>
      <template #header>
        <i class="pi pi-plus-circle"> </i>
        <span class="pl-1">Operazioni</span>
      </template>

      <prime-button
        v-if="data.item.numero"
        label="MODIFICA DATI FATTURA"
        icon="pi pi-directions"
        iconPos="right"
        class="p-button-secondary mr-3"
        :disabled="data.item.agyo.stato == 'INVIATO' ? true : false"
        @click="editFattura()"
      />
      <prime-button
        v-if="data.item.numero"
        label="APRI PDF FATTURA"
        icon="pi pi-download"
        iconPos="right"
        class="p-button-primary mr-3"
        @click="openFatturaPdf()"
      />
      <prime-button
        v-if="data.item.numero"
        label="CHECK FATTURA AGYO"
        icon="pi pi-eye"
        iconPos="right"
        class="p-button-primary mr-3"
        @click="checkFatturaAgyo()"
      />
      <prime-button
        v-if="data.item.numero"
        label="SCARICA DETTAGLIO PDF"
        icon="pi pi-file-pdf"
        iconPos="right"
        class="p-button-primary mr-3 mt-2"
        @click="downloadFatturaDettagliata()"
      />
      <prime-button
        v-if="data.item.numero"
        label="SCARICA DETTAGLIO ESTESO PDF"
        icon="pi pi-file-pdf"
        iconPos="right"
        class="p-button-primary mr-3 mt-2"
        @click="downloadFatturaEstesa()"
      />
    </prime-accordion-tab>
  </prime-accordion>

  <prime-accordion
    v-if="data.item.numero"
    class="box-operation-detail"
    :activeIndex="0"
  >
    <prime-accordion-tab>
      <template #header>
        <i class="pi pi-info-circle"></i>
        <span class="pl-1">Pagamento e Spedizione</span>
      </template>

      <div class="formgrid grid">
        <div class="field col-12 md:col-4">
          <div class="flex">
            <div class="mr-2">
              <i class="pi pi-wallet" style="fontsize: 3rem"></i>
            </div>
            <div class="flex flex-column">
              <div class="p-mb-2"><span>PAGAMENTO</span></div>
              <div>
                <span style="fontsize: 1rem; font-weight: bold">{{
                  data.item.info.pagamento || "-"
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <div class="flex">
            <div class="mr-2">
              <i class="pi pi-send" style="fontsize: 3rem"></i>
            </div>
            <div class="flex flex-column">
              <div class="p-mb-2"><span>SPEDIZIONE</span></div>
              <div>
                <span style="fontsize: 1rem; font-weight: bold">{{
                  data.item.info.spedizione || "-"
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <div class="flex">
            <div class="mr-2">
              <i class="pi pi-envelope" style="fontsize: 3rem"></i>
            </div>
            <div class="flex flex-column">
              <div class="p-mb-2"><span>EMAIL</span></div>
              <div>
                <a
                  v-if="data.item.info.email"
                  href="#"
                  class="email-log-link"
                  style="fontsize: 1rem; font-weight: bold"
                  @click.prevent="onEmailLogClick(data.item.info.email)"
                  >{{ data.item.info.email }}</a
                >
                <span v-else style="fontsize: 1rem; font-weight: bold">-</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </prime-accordion-tab>
  </prime-accordion>

  <SupplyRiepilogoSection
    v-if="data.item.numero"
    :cliente-id="data.item.info?.idcliente"
    :cliente-nome="data.item.info?.ragsoc"
    :saldo-residuo="fatturaSaldoResiduo"
    :supply-points="fatturaSupplyPoints"
    forniture-label="Fornitura associata"
  >
    <template #cards>
      <FatturaStornoCard
        :richiesta="richiestaStorno"
        :loading="richiestaStornoLoading"
      />
    </template>
  </SupplyRiepilogoSection>

  <prime-accordion :multiple="true" :activeIndex="[0]">
    <prime-accordion-tab>
      <template v-if="data.item.numero" #header>
        <span>Dettagli Fattura N.</span>&nbsp;<span>{{
          data.item.numero
        }}</span>
      </template>

      <div v-if="data.item.numero" class="formgrid grid">
        <div class="col-12 mr-2 mb-3">
          <h4>{{ data.item.numero }}</h4>
        </div>
        <div class="field col-12 md:col-4">
          <div class="flex">
            <div class="mr-2">
              <i class="pi pi-euro" style="fontsize: 4rem"></i>
            </div>
            <div class="flex flex-column">
              <div class="p-mb-2"><span>IMPORTO</span></div>
              <div>
                <span style="fontsize: 2rem; font-weight: bold">{{
                  currencyFormatter.format(
                    data.item.info.totale_fattura !== null
                      ? data.item.info.totale_fattura
                      : 0
                  )
                }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <div class="flex">
            <div class="mr-2">
              <i class="pi pi-user" style="fontsize: 4rem"></i>
            </div>
            <div class="flex flex-column">
              <div class="p-mb-2"><span>CLIENTE</span></div>
              <div>
                <a
                  :href="`/ask/clienti/${data.item.info.idcliente}/dettagli`"
                  target="_blank"
                  style="fontsize: 2rem; font-weight: bold"
                  >{{ data.item.info.ragsoc }}</a
                >
              </div>
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <div class="flex">
            <div class="mr-2">
              <i class="pi pi-file" style="fontsize: 3rem"></i>
            </div>
            <div class="flex flex-column">
              <div class="p-mb-2"><span>OFFERTA</span></div>
              <div class="flex justify-content-between align-items-center">
                <div>
                  <a
                    :href="`/ask/offerte/listini/${data.item.info.offertaid}/dettagli`"
                    target="_blank"
                    style="fontsize: 1rem; font-weight: bold"
                    >{{ data.item.info.offerta }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field col-12 md:col-4">
          <div class="flex">
            <div class="mr-2">
              <i class="pi pi-calendar" style="fontsize: 3rem"></i>
            </div>
            <div class="flex flex-column">
              <div class="p-mb-2"><span>DATA SCADENZA</span></div>
              <div>
                <span style="fontsize: 1rem; font-weight: bold">
                  {{
                    data.item.info.data_scadenza !== null
                      ? moment(data.item.info.data_scadenza).format(
                          "DD/MM/YYYY"
                        )
                      : ""
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <div class="flex">
            <div class="mr-2">
              <i class="pi pi-cog" style="fontsize: 3rem"></i>
            </div>
            <div class="flex flex-column">
              <div class="p-mb-2">
                <span>{{ data.item.info.tipo }}</span>
              </div>
              <div>
                <a
                  :href="`/ask/pods/${data.item.info.cod_pod}/dettagli`"
                  target="_blank"
                  v-if="data.item.info.pod"
                  style="fontsize: 1rem; font-weight: bold"
                  >{{ data.item.info.pod }}</a
                >
                <a
                  :href="`/ask/pdrs/${data.item.info.cod_pdr}/dettagli`"
                  target="_blank"
                  v-if="data.item.info.pdr"
                  style="fontsize: 1rem; font-weight: bold"
                  >{{ data.item.info.pdr }}</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-4">
          <div class="flex">
            <div class="mr-2">
              <i class="pi pi-file" style="fontsize: 3rem"></i>
            </div>
            <div class="flex flex-column">
              <div class="p-mb-2"><span>CONTRATTO</span></div>
              <div class="flex justify-content-between align-items-center">
                <div
                  v-if="data.item.info.code_contratto && data.item.info.cod_contratto"
                  class="ml-3"
                >
                  <a
                    :href="`/ask/contratti/vendita/${data.item.info.cod_contratto}/dettagli`"
                    target="_blank"
                    style="fontsize: 1rem; font-weight: bold"
                  >
                    {{ data.item.info.code_contratto }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4">
          <div class="m-2">
            <Checkbox
              @change="onChangeContestazione"
              v-model="data.item.info.contestazione"
              :binary="true"
            />
            <label class="ml-2">Contestazione</label>
          </div>
        </div>
        <div class="col-12 md:col-4">
          <div class="m-2">
            <Checkbox
              @change="onChangeSetPdfError"
              v-model="data.item.info.pdf_error"
              :binary="true"
            />
            <label class="ml-2">Clicca per rigenerare il pdf</label>
          </div>
        </div>
        <div v-if="isFatturaScartata" class="col-12 md:col-4">
          <div class="m-2 flex align-items-center">
            <prime-button
              label="Riemetti fattura"
              icon="pi pi-refresh"
              class="p-button-warning"
              :loading="riemettiFatturaLoading"
              :disabled="riemettiFatturaLoading"
              @click="onRiemettiFatturaClick"
            />
          </div>
        </div>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Competenze">
      <prime-data-table
        :value="data.item.voci_stornabili"
        responsiveLayout="scroll"
      >
        <prime-column field="periodo_rif" header="Mese">
          <template #body="{ data }">
            {{
              `${months[parseInt(data.periodo_rif.split("-")[0]) - 1]} ${
                data.periodo_rif.split("-")[1]
              }`
            }}
          </template>
        </prime-column>
        <prime-column field="totale_fattura" header="Importo">
          <template #body="{ data }">
            {{
              currencyFormatter.format(
                data.totale_fattura !== null ? data.totale_fattura : 0
              )
            }}
          </template>
        </prime-column>
        <prime-column
          field="type_doc"
          header="Tipologia documento"
        ></prime-column>
        <prime-column field="tipo_consumo" header="Tipologia"></prime-column>
        <prime-column field="totale_fattura" header="Consumo">
          <template #body="{ data }">
            {{
              floatFixFormatter.format(
                data.quantity !== null ? data.quantity : 0
              )
            }}
          </template>
        </prime-column>
      </prime-data-table>
    </prime-accordion-tab>

    <prime-accordion-tab header="Pagamenti">
      <div class="flex align-items-center justify-content-between mb-3 pagamenti-toolbar">
        <div>
          <span class="text-500">Saldo fattura:</span>
          <strong class="ml-2">{{ saldoFatturaFormatted }}</strong>
        </div>
        <div class="pagamenti-toolbar-actions">
          <prime-button
            label="Sposta credito"
            icon="pi pi-refresh"
            class="p-button-warning"
            :disabled="!data.item.numero"
            @click="onSpostaCreditoClick"
          />
          <span
            v-tooltip.top="richiediRimborsoTooltip"
            class="richiedi-rimborso-button-wrapper"
          >
            <prime-button
              label="Richiedi Rimborso"
              icon="pi pi-money-bill"
              class="p-button-info"
              :disabled="!data.item.numero || richiestaRimborsoEsistente"
              @click="onRichiediRimborsoClick"
            />
          </span>
        </div>
      </div>
      <prime-data-table :value="data.item.pagamenti" responsiveLayout="scroll">
        <prime-column field="data" header="Data" :sortable="true">
          <template #body="{ data }">
            {{
              data.data !== null ? moment(data.data).format("DD/MM/YYYY") : ""
            }}
          </template>
        </prime-column>
        <prime-column field="data_insert" header="Data Inserimento" :sortable="true">
          <template #body="{ data }">
            {{
              data.data_insert !== null ? moment(data.data_insert).format("DD/MM/YYYY") : ""
            }}
          </template>
        </prime-column>
        <prime-column field="value" header="Importo" :sortable="true">
          <template #body="{ data }">
            {{ currencyFormatter.format(data.value !== null ? data.value : 0) }}
          </template>
        </prime-column>
        <prime-column field="note" header="Note"></prime-column>
        <prime-column field="motivazione" header="Motivazione"></prime-column>
        <prime-column field="tp" header="Metodo"></prime-column>
        <prime-column field="tpm" header="Banca"></prime-column>
        <prime-column 
          v-if="hasCompensazionePayment || hasEstrattoContoPayment"
          :exportable="false" 
          header="Azioni"
        >
          <template #body="{ data }">
            <prime-button
              v-if="shouldShowEstrattoContoButton(data)"
              icon="pi pi-external-link"
              class="p-button-rounded p-button-info mr-2"
              @click="goToEstrattoContoRegularized(data)"
            />
            <prime-button
              v-if="shouldShowDeleteCompensazioneButton(data)"
              icon="pi pi-trash"
              class="p-button-rounded p-button-danger"
              @click="onDeletePaymentClick(data)"
            />
          </template>
        </prime-column>
      </prime-data-table>
    </prime-accordion-tab>

    <prime-accordion-tab header="Dettagli">
      <prime-accordion :multiple="true" :activeIndex="[0]">
        <prime-accordion-tab
          v-for="(details, period) in data.item.dettaglio"
          v-bind:key="period"
        >
          <template #header>
            <span>{{
              `${months[parseInt(period.split("-")[0]) - 1]} ${
                period.split("-")[1]
              }`
            }}</span>
          </template>

          <prime-data-table :value="details" responsiveLayout="scroll">
            <prime-column
              field="cod_voce"
              header="Voce"
              :sortable="true"
            ></prime-column>
            <prime-column field="qta" header="Quantita">
              <template #body="{ data }">
                {{ floatFormatter.format(data.qta !== null ? data.qta : 0) }}
              </template>
            </prime-column>
            <prime-column field="unitario" header="Prezzo Unitario (&euro;)">
              <template #body="{ data }">
                {{
                  floatFormatter.format(
                    data.unitario !== null ? data.unitario : 0
                  )
                }}
              </template>
            </prime-column>
            <prime-column
              field="aliquota"
              header="Aliquota IVA (%)"
            ></prime-column>
            <prime-column field="totale" header="Imponibile">
              <template #body="{ data }">
                {{
                  currencyFormatter.format(
                    data.totale !== null ? data.totale : 0
                  )
                }}
              </template>
            </prime-column>
            <prime-column field="iva" header="Importo IVA">
              <template #body="{ data }">
                {{ currencyFormatter.format(data.iva !== null ? data.iva : 0) }}
              </template>
            </prime-column>
            <prime-column field="totale_ivato" header="Totale">
              <template #body="{ data }">
                {{
                  currencyFormatter.format(
                    data.totale_ivato !== null ? data.totale_ivato : 0
                  )
                }}
              </template>
            </prime-column>
          </prime-data-table>
        </prime-accordion-tab>
      </prime-accordion>
    </prime-accordion-tab>

    <prime-accordion-tab header="Agyo">
      <div v-if="data.item.numero" class="flex flex-column agyo">
        <div class="stato"><b>Stato:</b> {{ data.item.agyo.stato }}</div>
        <div class="data" v-if="data.item.agyo.info">
          <b>Data: </b>
          {{
            data.item.agyo.info.data !== null
              ? moment(data.item.agyo.info.data).format("DD/MM/YYYY")
              : ""
          }}
        </div>
        <div class="source">
          <div class="" v-if="data.item.agyo.info.source == 'agyo'">
            By {{ data.item.agyo.info.source }}
          </div>
          <div v-if="data.item.agyo.info.source == 'contabilita'">
            By {{ data.item.agyo.info.source }}
          </div>
        </div>
      </div>
    </prime-accordion-tab>
    <prime-accordion-tab header="Info Posta">
      <div v-if="data.item.numero" class="flex flex-column agyo">
        <div v-if="infoPostaNumero && infoPostaNumero.success">
          <div class="stato">
            <b>Numero fattura:</b> {{ infoPostaNumero.numero_fattura || data.item.numero }}
          </div>
          <div class="data">
            <b>ID richiesta:</b> {{ infoPostaNumero.id_richiesta || "-" }}
          </div>
          <div class="data">
            <b>Stato servizio corrente:</b> {{ infoPostaNumero.stato_servizio_corrente || "-" }}
          </div>
          <div
            v-if="infoPostaNumero.stati_servizio && infoPostaNumero.stati_servizio.length"
            class="data mt-2"
          >
            <b>Stati:</b>
            <ul class="stati-posta-list">
              <li v-for="stato in infoPostaNumero.stati_servizio" :key="stato.id">
                <span class="stato-servizio">{{ stato.stato_servizio || "-" }}</span>
                <span class="stato-data">
                  - {{ formatPostaDate(stato.created_at) }}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div v-else class="data">
          <b>Esito:</b>
          {{
            (infoPostaNumero && infoPostaNumero.message)
              ? infoPostaNumero.message
              : "Nessuna informazione posta disponibile"
          }}
        </div>
      </div>
    </prime-accordion-tab>
  </prime-accordion>
  
  <prime-dialog
    v-model:visible="spostaCreditoDialog"
    :style="{ width: '520px' }"
    header="Sposta credito"
    :modal="true"
  >
    <div class="sposta-credito-dialog">
      <div class="flex align-items-stretch">
        <div class="sposta-credito-info flex flex-column">
          <p><strong>Banca:</strong> {{ spostaCreditoData.banca }}</p>
          <p><strong>Tipologia:</strong> {{ spostaCreditoData.tipologia }}</p>
          <p><strong>Data:</strong> {{ spostaCreditoData.data }}</p>
          <p><strong>Fattura:</strong> {{ spostaCreditoData.fattura }}</p>
        </div>
        <div class="sposta-credito-saldo flex flex-column align-items-end justify-content-center">
          <small class="text-500">Disponibile</small>
          <span>{{ currencyFormatter.format(spostaCreditoMaxImporto) }}</span>
        </div>
      </div>

      <div class="field mt-4">
        <label class="font-bold block mb-2">Fattura destinazione</label>
        <div class="flex gap-2">
          <InputText
            v-model="spostaCreditoFatturaDestinazione"
            placeholder="Inserisci il numero di fattura"
            class="w-full"
            :disabled="spostaCreditoSaldoLoading"
            @input="onSpostaCreditoDestinazioneInput"
            @keydown.enter.prevent="loadSpostaCreditoSaldoDestinazione"
          />
          <prime-button
            label="Carica"
            icon="pi pi-search"
            iconPos="left"
            class="ml-2 p-button-secondary flex justify-content-center align-items-center"
            :loading="spostaCreditoSaldoLoading"
            :disabled="!spostaCreditoFatturaDestinazione.trim() || spostaCreditoSaldoLoading"
            @click="loadSpostaCreditoSaldoDestinazione"
            style="min-width: 120px;"
          />
   
        </div>
        <small v-if="spostaCreditoDestinazioneError" class="p-error block mt-1">
          {{ spostaCreditoDestinazioneError }}
        </small>
        <small
          v-else-if="spostaCreditoDestinazioneCaricata"
          class="text-500 block mt-1"
        >
          Saldo destinazione:
          {{ currencyFormatter.format(spostaCreditoSaldoDestinazione) }}
        </small>
      </div>

      <div v-if="spostaCreditoDestinazioneCaricata" class="field mt-4">
        <label class="font-bold block mb-2">Importo da spostare</label>
        <InputNumber
          v-model="spostaCreditoImporto"
          mode="currency"
          currency="EUR"
          locale="it-IT"
          :min="0.01"
          :max="spostaCreditoMaxImporto > 0 ? spostaCreditoMaxImporto : null"
          class="w-full"
        />
        <small v-if="spostaCreditoMaxImporto > 0" class="text-500">
          Massimo disponibile: {{ currencyFormatter.format(spostaCreditoMaxImporto) }}
        </small>
        <small v-else class="text-500">
          Nessun credito disponibile su questa fattura
        </small>
      </div>
    </div>
    <template #footer>
      <prime-button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="closeSpostaCreditoDialog"
      />
      <prime-button
        label="Sposta"
        icon="pi pi-check"
        class="p-button-success"
        :disabled="!canConfirmSpostaCredito"
        @click="confirmSpostaCredito"
      />
    </template>
  </prime-dialog>

  <prime-dialog
    v-model:visible="richiediRimborsoDialog"
    :style="{ width: '580px' }"
    header="Richiedi Rimborso"
    :modal="true"
    :closable="!richiediRimborsoLoading"
  >
    <div
      class="richiedi-rimborso-dialog"
      :class="{ 'richiedi-rimborso-dialog--loading': richiediRimborsoLoading }"
    >
      <div v-if="richiediRimborsoLoading" class="richiedi-rimborso-dialog-loader">
        <ProgressSpinner style="width: 50px; height: 50px" />
        <span class="richiedi-rimborso-dialog-loader-text">Invio richiesta in corso...</span>
      </div>
      <div :class="{ 'richiedi-rimborso-dialog-content--hidden': richiediRimborsoLoading }">
      <div class="flex align-items-stretch">
        <div class="sposta-credito-info flex flex-column">
          <p><strong>Fattura:</strong> {{ data.item.numero || "-" }}</p>
          <p><strong>Cliente:</strong> {{ data.item.info?.ragsoc || "-" }}</p>
          <p><strong>Importo pagato:</strong> {{ importoPagatoFormatted }}</p>
          <p><strong>Saldo pre rimborso:</strong> {{ saldoPreRimborsoFormatted }}</p>
        </div>
      </div>
      <div class="field mt-4">
        <label class="font-bold block mb-2">Importo rimborso</label>
        <InputNumber
          :modelValue="richiediRimborsoImporto"
          mode="currency"
          currency="EUR"
          locale="it-IT"
          :min="0.01"
          class="w-full"
          :class="{ 'p-invalid': richiediRimborsoImportoError }"
          @update:modelValue="onRichiediRimborsoImportoChange"
        />
        <small v-if="richiediRimborsoImportoError" class="p-error block mt-1">
          {{ richiediRimborsoImportoError }}
        </small>
        <small v-else-if="richiediRimborsoMaxImporto > 0" class="text-500">
          Massimo richiedibile: {{ currencyFormatter.format(richiediRimborsoMaxImporto) }}
        </small>
        <small v-else class="text-500">
          Nessun importo disponibile per il rimborso
        </small>
      </div>
      <div class="field mt-4">
        <label class="font-bold block mb-2">Note <span class="required-mark">*</span></label>
        <Textarea
          v-model="richiediRimborsoNote"
          rows="3"
          autoResize
          class="w-full"
          :class="{ 'p-invalid': richiediRimborsoNoteTouched && !richiediRimborsoNote.trim() }"
          placeholder="Inserisci le note"
          @blur="richiediRimborsoNoteTouched = true"
        />
        <small
          v-if="richiediRimborsoNoteTouched && !richiediRimborsoNote.trim()"
          class="p-error block mt-1"
        >
          Le note sono obbligatorie
        </small>
      </div>
      </div>
    </div>
    <template #footer>
      <prime-button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        :disabled="richiediRimborsoLoading"
        @click="closeRichiediRimborsoDialog"
      />
      <prime-button
        label="Richiedi"
        icon="pi pi-check"
        class="p-button-success"
        :disabled="!canConfirmRichiediRimborso || richiediRimborsoLoading"
        :loading="richiediRimborsoLoading"
        @click="confirmRichiediRimborso"
      />
    </template>
  </prime-dialog>

  <prime-dialog
    v-model:visible="emailLogDialog"
    :style="{ width: '90vw' }"
    :contentStyle="{ maxHeight: '75vh', overflowY: 'auto' }"
    :header="emailLogDialogHeader"
    :modal="true"
    :maximizable="true"
  >
    <div v-if="emailLogLoading" class="text-center p-4">
      Caricamento log email...
    </div>
    <div v-else class="email-log-sections">
      <section class="email-log-section mb-4">
        <div class="flex align-items-center justify-content-between mb-2">
          <h5 class="m-0">Delivered</h5>
          <small class="text-500">{{ emailLogsDelivered.length }} record</small>
        </div>
        <div v-if="emailLogsDelivered.length === 0" class="text-center p-3 surface-50 border-round">
          Nessuna email delivered trovata.
        </div>
        <prime-data-table
          v-else
          :value="emailLogsDelivered"
          responsiveLayout="scroll"
          :scrollable="true"
          scrollHeight="280px"
          :paginator="emailLogsDelivered.length > 10"
          :rows="10"
        >
          <prime-column
            v-for="col in emailLogDeliveredColumnKeys"
            :key="`delivered-${col}`"
            :field="col"
            :header="formatEmailLogColumnHeader(col)"
            :sortable="true"
          >
            <template #body="{ data }">
              {{ formatEmailLogCell(data[col], col) }}
            </template>
          </prime-column>
        </prime-data-table>
      </section>

      <section class="email-log-section">
        <div class="flex align-items-center justify-content-between mb-2">
          <h5 class="m-0">Bollette Inviate</h5>
          <small class="text-500">{{ emailLogsSendingAsk.length }} record</small>
        </div>
        <div v-if="emailLogsSendingAsk.length === 0" class="text-center p-3 surface-50 border-round">
          Nessuna email "Bolletta Inviata" trovata.
        </div>
        <prime-data-table
          v-else
          :value="emailLogsSendingAsk"
          responsiveLayout="scroll"
          :scrollable="true"
          scrollHeight="280px"
          :paginator="emailLogsSendingAsk.length > 10"
          :rows="10"
        >
          <prime-column
            v-for="col in emailLogSendingAskColumnKeys"
            :key="`sendingask-${col}`"
            :field="col"
            :header="formatEmailLogColumnHeader(col)"
            :sortable="true"
          >
            <template #body="{ data }">
              {{ formatEmailLogCell(data[col], col) }}
            </template>
          </prime-column>
        </prime-data-table>
      </section>
    </div>
    <template #footer>
      <prime-button
        label="Chiudi"
        icon="pi pi-times"
        class="p-button-text"
        @click="closeEmailLogDialog"
      />
    </template>
  </prime-dialog>

  <prime-dialog
    v-model:visible="deleteCompensazioneDialog"
    :style="{ width: '450px' }"
    header="Conferma Eliminazione"
    :modal="true"
  >
    <div class="confirmation-content flex align-items-center">
      <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem; color: var(--red-500)" />
      <span>Sei sicuro di voler eliminare questa compensazione e i relativi movimenti collegati?</span>
    </div>
    <template #footer>
      <prime-button
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        @click="deleteCompensazioneDialog = false"
      />
      <prime-button
        label="Elimina"
        icon="pi pi-trash"
        class="p-button-danger"
        @click="confirmDeleteCompensazione"
      />
    </template>
  </prime-dialog>
</template>

<script>
import FattureService from "@/services/ask-management/fatture-clienti-service";
import Service from "@/services/ask-pratiche/gestione-pratiche";
import UtilityAgyoService from "@/services/ask-management/utility-agyo-service";
import Loader from "@/components/Loader.vue";
import SupplyRiepilogoSection from "@/components/ask/details/SupplyRiepilogoSection.vue";
import FatturaStornoCard from "@/components/ask/details/FatturaStornoCard.vue";
import PrimeAccordion from "primevue/accordion";
import PrimeAccordionTab from "primevue/accordiontab";
import PrimeButton from "primevue/button";
import PrimeDataTable from "primevue/datatable";
import PrimeColumn from "primevue/column";
import PrimeDialog from "primevue/dialog";

import moment from "moment";

export default {
  name: "ViewAskFattureClientiDetail",
  components: {
    Loader,
    SupplyRiepilogoSection,
    FatturaStornoCard,
    PrimeAccordion,
    PrimeAccordionTab,
    PrimeButton,
    PrimeDataTable,
    PrimeColumn,
    PrimeDialog,
  },

  data() {
    return {
      moment,
      loader: false,
      fatturaData: null,
      currencyFormatter: new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
      }),

      floatFixFormatter: new Intl.NumberFormat("it-IT", {
        maximumFractionDigits: 3,
      }),

      floatFormatter: new Intl.NumberFormat("it-IT", {
        maximumFractionDigits: 10,
      }),

      route: {
        params: null,
      },

      months: [
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ],

      data: {
        item: {},
      },
      infoPostaNumero: null,
      deleteCompensazioneDialog: false,
      selectedPayment: null,
      spostaCreditoDialog: false,
      spostaCreditoFatturaDestinazione: "",
      spostaCreditoImporto: null,
      spostaCreditoSaldoLoading: false,
      spostaCreditoDestinazioneCaricata: false,
      spostaCreditoSaldoDestinazione: null,
      spostaCreditoDestinazioneError: null,
      emailLogDialog: false,
      emailLogLoading: false,
      emailLogsDelivered: [],
      emailLogsSendingAsk: [],
      selectedEmail: "",
      richiestaStorno: null,
      richiestaStornoLoading: false,
      richiestaRimborsoEsistente: false,
      richiestaRimborso: null,
      dataConfirmedRimborso: null,
      richiediRimborsoDialog: false,
      richiediRimborsoImporto: null,
      richiediRimborsoImportoError: null,
      richiediRimborsoNote: "",
      richiediRimborsoNoteTouched: false,
      richiediRimborsoLoading: false,
      riemettiFatturaLoading: false,
    };
  },

  computed: {
    isFatturaScartata() {
      const esito = String(this.data?.item?.info?.esitoSDI || "")
        .toUpperCase()
        .trim();
      return esito === "SCARTATO";
    },
    emailLogDialogHeader() {
      return this.selectedEmail
        ? `Log email - ${this.selectedEmail}`
        : "Log email";
    },
    emailLogDeliveredColumnKeys() {
      return this.getEmailLogColumnKeys(this.emailLogsDelivered, [
        "email",
        "event",
        "data_invio",
      ]);
    },
    emailLogSendingAskColumnKeys() {
      return this.getEmailLogColumnKeys(this.emailLogsSendingAsk, [
        "email",
        "event",
        "title",
        "creation_time",
      ]);
    },
    hasCompensazionePayment() {
      if (!this.data.item.pagamenti || !Array.isArray(this.data.item.pagamenti)) {
        return false;
      }
      return this.data.item.pagamenti.some(
        (payment) => payment.cod_type_pay_mode === 5
      );
    },
    hasEstrattoContoPayment() {
      if (!this.data.item.pagamenti || !Array.isArray(this.data.item.pagamenti)) {
        return false;
      }
      return this.data.item.pagamenti.some((payment) => {
        const codEstrattoConto =
          payment?.cod_estrattoconto ?? payment?.cod_estratto_conto ?? null;
        return codEstrattoConto !== null && codEstrattoConto !== undefined && codEstrattoConto !== "";
      });
    },
    saldoFatturaFormatted() {
      return this.currencyFormatter.format(this.getSaldoFattura());
    },
    fatturaSaldoResiduo() {
      const saldo = this.getSaldoFattura();
      return !Number.isNaN(saldo) && saldo > 0 ? saldo : 0;
    },
    fatturaSupplyPoints() {
      const info = this.data?.item?.info || {};
      const points = [];

      const podId = info.cod_pod || info.id_pod || null;
      const podCode = info.pod || info.code_pod || null;
      if ((podId && Number(podId) > 0) || podCode) {
        points.push({
          id: podId && Number(podId) > 0 ? podId : null,
          type: 'pod',
          code: podCode,
        });
      }

      const pdrId = info.cod_pdr || info.id_pdr || null;
      const pdrCode = info.pdr || info.code_pdr || null;
      if ((pdrId && Number(pdrId) > 0) || pdrCode) {
        points.push({
          id: pdrId && Number(pdrId) > 0 ? pdrId : null,
          type: 'pdr',
          code: pdrCode,
        });
      }

      return points;
    },
    spostaCreditoMaxImporto() {
      return this.getCreditoDisponibile();
    },
    canConfirmSpostaCredito() {
      const importo = parseFloat(this.spostaCreditoImporto ?? 0);
      if (
        !this.spostaCreditoDestinazioneCaricata ||
        importo < 0.01 ||
        !this.spostaCreditoFatturaDestinazione.trim()
      ) {
        return false;
      }
      const max = this.spostaCreditoMaxImporto;
      if (max >= 0.01 && importo > max + 0.001) {
        return false;
      }
      return true;
    },
    spostaCreditoData() {
      const info = this.data?.item?.info;

      return {
        banca: "N/D",
        tipologia: "Compensazione",
        data: info?.data_emissione
          ? this.moment(info.data_emissione).format("DD/MM/YYYY")
          : this.moment().format("DD/MM/YYYY"),
        fattura: this.data?.item?.numero || "-",
        saldo: this.saldoFatturaFormatted,
      };
    },
    richiediRimborsoMaxImporto() {
      // Si rimborsa quanto pagato oppure, per le fatture a saldo negativo (note di credito), il credito del cliente
      const pagato = this.getImportoPagato();
      const saldo = this.getSaldoFattura();
      const credito = !Number.isNaN(saldo) && saldo < 0 ? parseFloat((-saldo).toFixed(2)) : 0;
      return Math.max(pagato, credito);
    },
    importoPagatoFormatted() {
      return this.currencyFormatter.format(this.getImportoPagato());
    },
    saldoPreRimborsoFormatted() {
      return this.currencyFormatter.format(this.getSaldoFattura());
    },
    canConfirmRichiediRimborso() {
      const importo = parseFloat(this.richiediRimborsoImporto ?? 0);
      if (
        importo < 0.01 ||
        !this.data?.item?.numero ||
        this.richiediRimborsoImportoError ||
        !String(this.richiediRimborsoNote || "").trim()
      ) {
        return false;
      }

      const max = this.richiediRimborsoMaxImporto;
      if (max < 0.01 || importo > max + 0.001) {
        return false;
      }

      return true;
    },
    richiediRimborsoTooltip() {
      if (!this.richiestaRimborsoEsistente) {
        return null;
      }

      const parts = [];
      const dataRichiesta = this.richiestaRimborso?.data;
      if (dataRichiesta && this.moment(dataRichiesta).isValid()) {
        parts.push(
          `Il rimborso è stato già richiesto il ${this.formatRimborsoDate(dataRichiesta)}`
        );
      } else {
        parts.push("Il rimborso è stato già richiesto");
      }

      const dataConferma =
        this.richiestaRimborso?.data_confirmed_rimborso ??
        this.dataConfirmedRimborso;
      if (dataConferma && this.moment(dataConferma).isValid()) {
        parts.push(
          `Rimborso confermato il ${this.formatRimborsoDate(dataConferma)}`
        );
      }

      return parts.join(". ");
    },
  },

  created() {
    this.route.params = this.$route.params;
    // console.log(this.route.params)
    this.Service = new Service(this.$http, this.$eventBus);
    this.fattureService = new FattureService(this.$http, this.$eventBus);
    this.agyoService = new UtilityAgyoService(this.$http, this.$eventBus);
    this.getDettaglioFattura(this.route.params.numero);
  },

  methods: {
    getSaldoFattura() {
      const item = this.data?.item;
      const info = item?.info;

      if (info?.saldo !== null && info?.saldo !== undefined) {
        return parseFloat(info.saldo);
      }

      if (item?.saldo !== null && item?.saldo !== undefined) {
        return parseFloat(item.saldo);
      }

      if (item?.contabilita?.saldo !== null && item?.contabilita?.saldo !== undefined) {
        return parseFloat(item.contabilita.saldo);
      }

      if (info?.totale_fattura != null && info?.pagato != null) {
        return parseFloat((info.totale_fattura - info.pagato).toFixed(2));
      }

      return 0;
    },

    getImportoPagato() {
      const item = this.data?.item;
      const info = item?.info;

      const directValues = [
        info?.pagato,
        item?.pagato,
        item?.contabilita?.pagato,
      ];

      for (const value of directValues) {
        if (value !== null && value !== undefined && value !== "") {
          const pagato = parseFloat(value);
          if (!Number.isNaN(pagato) && pagato > 0) {
            return parseFloat(pagato.toFixed(2));
          }
        }
      }

      const totale = parseFloat(info?.totale_fattura ?? item?.totale_fattura ?? 0);
      if (!Number.isNaN(totale) && totale > 0) {
        const saldo = this.getSaldoFattura();
        if (!Number.isNaN(saldo)) {
          const pagato = parseFloat((totale - saldo).toFixed(2));
          if (pagato > 0) {
            return pagato;
          }
        }
      }

      if (Array.isArray(item?.pagamenti) && item.pagamenti.length > 0) {
        const sum = item.pagamenti.reduce((acc, payment) => {
          const value = parseFloat(payment?.value ?? 0);
          return acc + (Number.isNaN(value) ? 0 : value);
        }, 0);

        if (sum > 0) {
          return parseFloat(sum.toFixed(2));
        }
      }

      return 0;
    },

    getCreditoDisponibile() {
      const saldo = this.getSaldoFattura();
      if (saldo < -0.009) {
        return parseFloat(Math.abs(saldo).toFixed(2));
      }

      const info = this.data?.item?.info;
      const totale = parseFloat(info?.totale_fattura ?? 0);
      const pagato = parseFloat(info?.pagato ?? 0);

      if (totale < -0.009) {
        const disponibile = Math.abs(totale) - pagato;
        return disponibile > 0 ? parseFloat(disponibile.toFixed(2)) : parseFloat(Math.abs(totale).toFixed(2));
      }

      return 0;
    },

    getSpostaCreditoErrorMessage(res) {
      return this.getApiErrorMessage(res, "Errore durante lo spostamento del credito");
    },

    getApiErrorMessage(res, fallback) {
      const payload = res?.data ?? res ?? {};
      if (payload.error) {
        return typeof payload.error === "string" ? payload.error : JSON.stringify(payload.error);
      }

      if (res?.meta?.error) {
        return typeof res.meta.error === "string" ? res.meta.error : JSON.stringify(res.meta.error);
      }

      if (payload.validate) {
        const messages = Object.values(payload.validate).flat();
        if (messages.length > 0) {
          return messages.join(" ");
        }
      }

      if (res?.meta?.validate) {
        const messages = Object.values(res.meta.validate).flat();
        if (messages.length > 0) {
          return messages.join(" ");
        }
      }

      if (payload.message) {
        return payload.message;
      }

      return fallback;
    },

    async loadRichiestaStorno(numero) {
      this.richiestaStorno = null;

      if (!numero) {
        return;
      }

      this.richiestaStornoLoading = true;
      try {
        const res = await this.fattureService.getRichiestaStorno(numero);
        const payload = res?.data ?? res ?? {};
        this.richiestaStorno = payload.richiesta_storno ?? null;
      } catch (error) {
        console.error("Errore durante il recupero della richiesta storno:", error);
      } finally {
        this.richiestaStornoLoading = false;
      }
    },

    async loadRichiestaRimborso(numero) {
      this.richiestaRimborsoEsistente = false;
      this.richiestaRimborso = null;
      this.dataConfirmedRimborso = null;

      if (!numero) {
        return;
      }

      try {
        const res = await this.fattureService.getRichiestaRimborso(numero);
        const inner = res?.data ?? res ?? {};
        const payload =
          inner?.esistente !== undefined
            ? inner
            : inner?.data ?? inner;
        this.richiestaRimborsoEsistente = !!payload.esistente;
        this.richiestaRimborso = payload.richiesta_rimborso ?? null;
        this.dataConfirmedRimborso =
          payload.data_confirmed_rimborso ??
          payload.richiesta_rimborso?.data_confirmed_rimborso ??
          null;
      } catch (error) {
        console.error("Errore durante il recupero della richiesta rimborso:", error);
      }
    },

    formatRimborsoDate(value) {
      if (!value) {
        return "-";
      }

      const m = this.moment(value);
      return m.isValid() ? m.format("DD/MM/YYYY HH:mm") : value;
    },

    onRichiediRimborsoClick() {
      const max = this.richiediRimborsoMaxImporto;
      this.richiediRimborsoImporto = max > 0 ? max : null;
      this.richiediRimborsoImportoError = null;
      this.richiediRimborsoNote = "";
      this.richiediRimborsoNoteTouched = false;
      this.richiediRimborsoDialog = true;
    },

    onRichiediRimborsoImportoChange(value) {
      this.richiediRimborsoImporto = value;

      const max = this.richiediRimborsoMaxImporto;
      if (value !== null && value !== undefined && max >= 0.01) {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed) && parsed > max + 0.001) {
          this.richiediRimborsoImportoError =
            "Non puoi richiedere un rimborso più alto del massimo richiedibile.";
          return;
        }
      }

      this.richiediRimborsoImportoError = null;
    },

    getSaldoPreRimborso() {
      return parseFloat(this.getSaldoFattura().toFixed(2));
    },

    closeRichiediRimborsoDialog() {
      if (this.richiediRimborsoLoading) {
        return;
      }

      this.richiediRimborsoDialog = false;
      this.richiediRimborsoImporto = null;
      this.richiediRimborsoImportoError = null;
      this.richiediRimborsoNote = "";
      this.richiediRimborsoNoteTouched = false;
      this.richiediRimborsoLoading = false;
    },

    async confirmRichiediRimborso() {
      const numero = String(this.data?.item?.numero || "").trim().toUpperCase();
      const importo = parseFloat(parseFloat(this.richiediRimborsoImporto ?? 0).toFixed(2));

      if (!numero) {
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Numero fattura non disponibile",
          life: 4000,
        });
        return;
      }

      if (importo < 0.01) {
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Inserisci un importo valido",
          life: 4000,
        });
        return;
      }

      if (this.richiediRimborsoMaxImporto < 0.01) {
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Nessun importo pagato disponibile per il rimborso",
          life: 4000,
        });
        return;
      }

      if (importo > this.richiediRimborsoMaxImporto + 0.001) {
        this.richiediRimborsoImportoError =
          "Non puoi richiedere un rimborso più alto del massimo richiedibile.";
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: this.richiediRimborsoImportoError,
          life: 4000,
        });
        return;
      }

      const note = String(this.richiediRimborsoNote || "").trim();
      if (!note) {
        this.richiediRimborsoNoteTouched = true;
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Le note sono obbligatorie",
          life: 4000,
        });
        return;
      }

      this.richiediRimborsoLoading = true;

      try {
        const res = await this.fattureService.insertRichiestaRimborso({
          numero,
          importo,
          saldo_pre_rimborso: this.getSaldoPreRimborso(),
          note,
        });
        const payload = res?.data ?? res ?? {};
        const isSuccess =
          (payload && payload.success) ||
          (res && res.meta && res.meta.success);

        if (isSuccess) {
          const richiestaRimborso =
            payload.richiesta_rimborso ??
            payload.data?.richiesta_rimborso ??
            null;

          await this.fattureService.saveLogRichiestaRimborso({
            numero,
            saldo: this.getSaldoPreRimborso(),
            id: richiestaRimborso?.id ?? 0,
          });

          this.$toast.add({
            severity: "success",
            summary: "Successo",
            detail: "Richiesta rimborso inviata correttamente",
            life: 3000,
          });
          await this.loadRichiestaRimborso(numero);
          this.richiediRimborsoLoading = false;
          this.closeRichiediRimborsoDialog();
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: this.getApiErrorMessage(res, "Errore durante l'inserimento della richiesta rimborso"),
            life: 5000,
          });
        }
      } catch (error) {
        const detail =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Errore durante l'inserimento della richiesta rimborso";
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: typeof detail === "string" ? detail : "Errore durante l'inserimento della richiesta rimborso",
          life: 5000,
        });
      } finally {
        this.richiediRimborsoLoading = false;
      }
    },

    getEmailLogColumnKeys(rows, preferredOrder = []) {
      if (!rows?.length) {
        return [];
      }

      const keys = Object.keys(rows[0]);
      const ordered = preferredOrder.filter((key) => keys.includes(key));
      const remaining = keys.filter((key) => !ordered.includes(key));

      return [...ordered, ...remaining];
    },

    formatEmailLogColumnHeader(col) {
      const labels = {
        id: "ID",
        email: "Email",
        event: "Evento",
        title: "Titolo",
        data_invio: "Data invio",
        creation_time: "Data creazione",
        timestamp: "Timestamp",
        status: "Stato",
        reason: "Motivo",
        sg_message_id: "Message ID",
        sg_event_id: "Event ID",
        created_at: "Creato il",
        updated_at: "Aggiornato il",
      };

      return labels[col] || col.replace(/_/g, " ");
    },

    formatEmailLogCell(value, col) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }

      if (
        /(date|timestamp|created_at|updated_at|data_invio|creation_time)/i.test(col) &&
        moment(value).isValid()
      ) {
        return moment(value).format("DD/MM/YYYY HH:mm");
      }

      return value;
    },

    closeEmailLogDialog() {
      this.emailLogDialog = false;
      this.emailLogsDelivered = [];
      this.emailLogsSendingAsk = [];
      this.selectedEmail = "";
      this.emailLogLoading = false;
    },

    async onEmailLogClick(email) {
      if (!email) {
        return;
      }

      this.selectedEmail = email;
      this.emailLogDialog = true;
      this.emailLogsDelivered = [];
      this.emailLogsSendingAsk = [];
      this.emailLogLoading = true;

      try {
        const res = await this.fattureService.findLogByEmail(email);
        const payload = res?.data ?? res ?? {};
        this.emailLogsDelivered = Array.isArray(payload.delivered)
          ? payload.delivered
          : [];
        this.emailLogsSendingAsk = Array.isArray(payload.sendingask)
          ? payload.sendingask
          : [];
      } catch (error) {
        console.error("Errore durante il recupero dei log email:", error);
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il recupero dei log email",
          life: 4000,
        });
        this.closeEmailLogDialog();
      } finally {
        this.emailLogLoading = false;
      }
    },

    onSpostaCreditoClick() {
      this.spostaCreditoFatturaDestinazione = "";
      this.spostaCreditoImporto = null;
      this.spostaCreditoSaldoLoading = false;
      this.spostaCreditoDestinazioneCaricata = false;
      this.spostaCreditoSaldoDestinazione = null;
      this.spostaCreditoDestinazioneError = null;
      this.spostaCreditoDialog = true;
    },

    closeSpostaCreditoDialog() {
      this.spostaCreditoDialog = false;
      this.spostaCreditoFatturaDestinazione = "";
      this.spostaCreditoImporto = null;
      this.spostaCreditoSaldoLoading = false;
      this.spostaCreditoDestinazioneCaricata = false;
      this.spostaCreditoSaldoDestinazione = null;
      this.spostaCreditoDestinazioneError = null;
    },

    onSpostaCreditoDestinazioneInput() {
      if (
        !this.spostaCreditoDestinazioneCaricata &&
        !this.spostaCreditoDestinazioneError &&
        this.spostaCreditoImporto === null
      ) {
        return;
      }

      this.spostaCreditoDestinazioneCaricata = false;
      this.spostaCreditoSaldoDestinazione = null;
      this.spostaCreditoDestinazioneError = null;
      this.spostaCreditoImporto = null;
    },

    async loadSpostaCreditoSaldoDestinazione() {
      const numeroPartenza = String(this.data?.item?.numero || "").trim().toUpperCase();
      const numeroDestinazione = String(this.spostaCreditoFatturaDestinazione || "")
        .trim()
        .toUpperCase();

      this.spostaCreditoDestinazioneError = null;
      this.spostaCreditoDestinazioneCaricata = false;
      this.spostaCreditoSaldoDestinazione = null;
      this.spostaCreditoImporto = null;

      if (!numeroDestinazione) {
        this.spostaCreditoDestinazioneError = "Inserisci il numero fattura destinazione";
        return;
      }

      if (numeroPartenza && numeroDestinazione === numeroPartenza) {
        this.spostaCreditoDestinazioneError =
          "La fattura di partenza e quella di destinazione devono essere diverse";
        return;
      }

      this.spostaCreditoFatturaDestinazione = numeroDestinazione;
      this.spostaCreditoSaldoLoading = true;

      try {
        const res = await this.fattureService.getSaldoFattura(numeroDestinazione);
        const payload = res?.data ?? res ?? {};
        const isSuccess =
          (payload && payload.success) ||
          (res && res.meta && res.meta.success);

        if (!isSuccess || payload.saldo === undefined || payload.saldo === null) {
          this.spostaCreditoDestinazioneError = this.getApiErrorMessage(
            res,
            "Fattura destinazione non trovata"
          );
          return;
        }

        const saldoDestinazione = parseFloat(payload.saldo);
        if (Number.isNaN(saldoDestinazione)) {
          this.spostaCreditoDestinazioneError = "Saldo destinazione non valido";
          return;
        }

        const disponibile = this.getCreditoDisponibile();
        const saldoDaCoprire = Math.max(0, parseFloat(saldoDestinazione.toFixed(2)));
        const proposto =
          saldoDaCoprire > disponibile + 0.001
            ? disponibile
            : saldoDaCoprire;

        this.spostaCreditoSaldoDestinazione = saldoDaCoprire;
        this.spostaCreditoDestinazioneCaricata = true;
        this.spostaCreditoImporto = proposto >= 0.01 ? proposto : null;

        if (proposto < 0.01) {
          this.spostaCreditoDestinazioneError =
            disponibile < 0.01
              ? "Nessun credito disponibile su questa fattura"
              : "La fattura destinazione non ha un saldo da coprire";
        }
      } catch (error) {
        const detail =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Errore durante il caricamento del saldo destinazione";
        this.spostaCreditoDestinazioneError =
          typeof detail === "string" ? detail : "Errore durante il caricamento del saldo destinazione";
      } finally {
        this.spostaCreditoSaldoLoading = false;
      }
    },

    async confirmSpostaCredito() {
      const numeroPartenza = String(this.data?.item?.numero || "").trim().toUpperCase();
      const numeroDestinazione = String(this.spostaCreditoFatturaDestinazione || "").trim().toUpperCase();
      const importo = parseFloat(parseFloat(this.spostaCreditoImporto ?? 0).toFixed(2));

      if (!numeroPartenza) {
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Numero fattura di partenza non disponibile",
          life: 4000,
        });
        return;
      }

      if (!numeroDestinazione) {
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Inserisci il numero fattura destinazione",
          life: 4000,
        });
        return;
      }

      if (numeroDestinazione === numeroPartenza) {
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "La fattura di partenza e quella di destinazione devono essere diverse",
          life: 4000,
        });
        return;
      }

      if (importo < 0.01) {
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Inserisci un importo valido da spostare",
          life: 4000,
        });
        return;
      }

      if (this.spostaCreditoMaxImporto >= 0.01 && importo > this.spostaCreditoMaxImporto + 0.001) {
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: `L'importo non può superare ${this.currencyFormatter.format(this.spostaCreditoMaxImporto)}`,
          life: 4000,
        });
        return;
      }

      const payload = {
        numero_partenza: numeroPartenza,
        numero: numeroDestinazione,
        importo,
        data: this.moment().format("YYYY-MM-DD"),
      };

      this.loader = true;

      try {
        const res = await this.fattureService.spostamentoCreditoFattura(payload);
        const isSuccess =
          (res && res.data && res.data.success) ||
          (res && res.meta && res.meta.success) ||
          (res && res.success);

        if (isSuccess) {
          this.$toast.add({
            severity: "success",
            summary: "Successo",
            detail: "Credito spostato correttamente",
            life: 3000,
          });
          this.closeSpostaCreditoDialog();
          await this.getDettaglioFattura(numeroPartenza);
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: this.getSpostaCreditoErrorMessage(res),
            life: 5000,
          });
        }
      } catch (error) {
        const detail =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Errore durante lo spostamento del credito";
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: typeof detail === "string" ? detail : "Errore durante lo spostamento del credito",
          life: 5000,
        });
      } finally {
        this.loader = false;
      }
    },

    shouldShowEstrattoContoButton(payment) {
      const codEstrattoConto =
        payment?.cod_estrattoconto ?? payment?.cod_estratto_conto ?? null;
      return (
        codEstrattoConto !== null &&
        codEstrattoConto !== undefined &&
        codEstrattoConto !== ""
      );
    },

    _isBackendSingleDeleteCandidate(payment) {
      if (!payment) return false;

      const codTypePayMode = Number(payment.cod_type_pay_mode);
      if (Number.isNaN(codTypePayMode) || codTypePayMode !== 5) return false;

      const codTypePay = Number(payment.cod_type_pay);
      if (Number.isNaN(codTypePay) || codTypePay !== 9) return false;

      const codEstrattoConto =
        payment?.cod_estrattoconto ?? payment?.cod_estratto_conto ?? null;
      if (codEstrattoConto !== null && codEstrattoConto !== undefined && codEstrattoConto !== "") {
        return false;
      }

      const note = String(payment.note ?? "");
      if (/addebito\s+sdd/i.test(note)) return false;

      return true;
    },

    _extractInvoiceNumbersFromNote(note) {
      const raw = String(note ?? "").toUpperCase();
      if (!raw) return [];

      const tokens = raw.split(/[^A-Z0-9]+/).filter(Boolean);
   
      return tokens.filter((t) => t.length >= 6 && /[A-Z]/.test(t) && /\d/.test(t));
    },

    shouldShowDeleteCompensazioneButton(payment) {
      if (!payment) return false;

      const codTypePayMode = Number(payment.cod_type_pay_mode);
      if (Number.isNaN(codTypePayMode) || codTypePayMode !== 5) return false;

      const idPayment =
        payment?.id ?? payment?.id_payment ?? payment?.idPayment ?? null;
      const hasIdPayment = idPayment !== null && idPayment !== undefined && idPayment !== "";
      const numeroFattura = this.data?.item?.numero ?? null;
      const value = payment?.value ?? null;
      const hasNumeroValue = !!numeroFattura && value !== null && value !== undefined && value !== "";

      if (!hasIdPayment && !hasNumeroValue) return false;

      if (this._isBackendSingleDeleteCandidate(payment)) return true;

      const invoices = this._extractInvoiceNumbersFromNote(payment.note);
      return invoices.length > 0;
    },

    goToEstrattoContoRegularized(payment) {
      const codEstrattoConto =
        payment?.cod_estrattoconto ?? payment?.cod_estratto_conto ?? null;
      if (!codEstrattoConto) return;

      const path = `/estratti-conto/detail/regularized/${codEstrattoConto}`;
      if (this.$router && typeof this.$router.push === "function") {
        this.$router.push(path);
      } else {
        window.location.href = path;
      }
    },

    async getDettaglioFattura(numero) {
      // this.table.loading = true
      const res = await this.fattureService.getDettaglioFattura(numero)
      this.data.item = res.item;
      this.convertTinyInBoolean();
      document.title =
        "numero" in this.data.item
          ? document.title + " - " + this.data.item.numero
          : document.title;

      if (this.data.item && this.data.item.numero) {
        await this.getInfoPostaNumero(this.data.item.numero)
        await this.loadRichiestaRimborso(this.data.item.numero)
        await this.loadRichiestaStorno(this.data.item.numero)
      }
      // this.table.loading = false
    },

    async getInfoPostaNumero(numeroFattura) {
      const res = await this.fattureService.getInfoPostaNumero(numeroFattura)
      this.infoPostaNumero = res.item || null
      if (this.data.item && this.data.item.info) {
        this.data.item.info_posta_numero = this.infoPostaNumero
      }
    },
    formatPostaDate(value) {
      if (!value) return "-"
      const m = this.moment(value)
      return m.isValid() ? m.format("DD/MM/YYYY HH:mm:ss") : value
    },
    editFattura() {
      if (Object.entries(this.data.item).length != 0) {
        this.$eventBus.emit("show-dialog-page", {
          page: "fattura-modifica-dati",
          title: "Modifica dati fattura",
          data: this.data.item,
          maximize: false,

          buttonOk: {
            label: "Cambia",
            icon: "pi pi-check",
            classCss: "",
            visible: true,
            disabled: false,
          },

          buttonCancel: {
            label: "Chiudi",
            icon: "pi pi-times",
            classCss: "p-button-secondary",
            visible: true,
            disabled: false,
          },
        });
      }
    },
    openFatturaPdf() {
      this.loader = true;
      this.fattureService.openFatturaPdf(
        this.data.item.numero, 
        this.data.item.info.data_emissione
      ).finally(() => {
        this.loader = false;
      });
    },
    convertTinyInBoolean() {
      if ("info" in this.data.item) {
        this.data.item.info.contestazione = !!this.data.item.info.contestazione;
        const pe = this.data.item.info.pdf_error ?? this.data.item?.pdf_error;
        this.data.item.info.pdf_error = Number(pe) === 1;
      }
    },

    onRiemettiFatturaClick() {
      const numero = String(this.data?.item?.numero || "").trim();
      if (!numero || this.riemettiFatturaLoading) {
        return;
      }

      const message = `Vuoi riemettere la fattura ${numero}?`;
      if (this.$confirm?.require) {
        this.$confirm.require({
          message,
          header: "Conferma",
          icon: "pi pi-info-circle",
          acceptLabel: "Si",
          rejectLabel: "No",
          accept: () => {
            this.riemettiFattura(numero);
          },
        });
        return;
      }

      if (window.confirm(message)) {
        this.riemettiFattura(numero);
      }
    },

    async riemettiFattura(numero) {
      this.riemettiFatturaLoading = true;
      this.loader = true;

      try {
        const res = await this.agyoService.resetScartateByNumeri([numero]);
        if (!res) {
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Errore durante la riemissione della fattura",
            life: 4000,
          });
          return;
        }

        this.$toast.add({
          severity: "success",
          summary: "Successo",
          detail: `Fattura ${numero} rimessa in emissione`,
          life: 3000,
        });
        await this.getDettaglioFattura(numero);
      } catch (error) {
        const detail =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Errore durante la riemissione della fattura";
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: typeof detail === "string" ? detail : "Errore durante la riemissione della fattura",
          life: 4000,
        });
      } finally {
        this.riemettiFatturaLoading = false;
        this.loader = false;
      }
    },

    async checkFatturaAgyo() {
      this.loader = true;
      const numeroFattura = this.data.item.numero;

      try {
        const response = await this.Service.checkFatturaAgyo(numeroFattura);

        const jsonResponse = JSON.stringify(response, null, 2);

        const newWindow = window.open("", "_blank");
        newWindow.document.write(
          "<html><head><title>Dettagli Fattura Agyo</title></head><body>"
        );
        newWindow.document.write("<pre>" + jsonResponse + "</pre>");
        newWindow.document.write("</body></html>");
        newWindow.document.close();
      } catch (error) {
        console.error("Errore durante la verifica della fattura:", error);

        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Fattura Non Inviata",
          life: 3000,
        });
      } finally {
        this.loader = false;
      }
    },

    onChangeContestazione() {
      this.loader = true;
      this.fattureService
        .changeFatturaContestazione(this.data.item)
        .then((res) => {
          if (res.item) {
            this.$toast.add({
              severity: "success",
              summary: "Successo",
              detail: "Dato modificato",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore nella modifica",
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    onChangeSetPdfError() {
      const numero = this.data.item.numero;
      if (!numero) return;
      const nuovoValore = this.data.item.info.pdf_error;
      this.loader = true;
      this.fattureService
        .setPdfError(numero, nuovoValore)
        .then((res) => {
          const ok = res?.success;
          if (ok) {
            if (res.pdf_error !== undefined) {
              this.data.item.info.pdf_error = !!res.pdf_error;
            }
            this.$toast.add({
              severity: "success",
              summary: "Successo",
              detail: res?.message || (this.data.item.info.pdf_error ? "Valore impostato, il PDF verrà rigenerato" : "Valore azzerato"),
              life: 3000,
            });
          } else {
            this.data.item.info.pdf_error = !nuovoValore;
            this.$toast.add({
              severity: "error",
              summary: "Errore",
              detail: res?.message || "Errore",
              life: 3000,
            });
          }
        })
        .catch((err) => {
          this.data.item.info.pdf_error = !nuovoValore;
          const msg = err?.response?.data?.message || "Errore durante l'aggiornamento";
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: msg,
            life: 3000,
          });
        })
        .finally(() => {
          this.loader = false;
        });
    },
    async downloadFatturaDettagliata() {
      this.loader = true;
      try {
        await this.fattureService.getFatturaDettagliataPdf(this.data.item.numero);
      } catch (error) {
        console.error("Errore durante il download del PDF:", error);
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il download del PDF",
          life: 3000,
        });
      } finally {
        this.loader = false;
      }
    },

    async downloadFatturaEstesa() {
      this.loader = true;
      try {
        await this.fattureService.getFatturaEstesaPdf(this.data.item.numero);
      } catch (error) {
        console.error("Errore durante il download del PDF esteso:", error);
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il download del PDF esteso",
          life: 3000,
        });
      } finally {
        this.loader = false;
      }
    },

    onDeletePaymentClick(payment) {
      this.selectedPayment = payment;
      this.deleteCompensazioneDialog = true;
    },

    async confirmDeleteCompensazione() {
      if (!this.selectedPayment) {
        return;
      }

      this.deleteCompensazioneDialog = false;
      this.loader = true;

      try {
        const numero = this.data.item.numero;
        const cod_type_pay_mode = this.selectedPayment.cod_type_pay_mode;
        const value = this.selectedPayment.value;
        const id_payment =
          this.selectedPayment.id !== undefined && this.selectedPayment.id !== null
            ? this.selectedPayment.id
            : this.selectedPayment.id_payment !== undefined && this.selectedPayment.id_payment !== null
              ? this.selectedPayment.id_payment
              : null;

        const res = await this.fattureService.deleteCompensazioneFattura({
          id_payment,
          numero,
          cod_type_pay_mode,
          value,
        });

        const isSuccess = (res && res.data && res.data.success) || (res && res.meta && res.meta.success);

        if (isSuccess) {
          const deletedCount = res.data?.deleted_count || 0;
          const detailMessage = deletedCount > 0 
            ? `Compensazione eliminata correttamente (${deletedCount} movimenti eliminati)`
            : "Compensazione eliminata correttamente";

          this.$toast.add({
            severity: "success",
            summary: "Successo",
            detail: detailMessage,
            life: 3000,
          });

          this.getDettaglioFattura(numero);
        } else {
          const detail =
            (res &&
              res.data &&
              (res.data.message ||
                (res.data.error && res.data.error.toString && res.data.error.toString()) ||
                "Errore nella cancellazione della compensazione")) ||
            "Errore nella cancellazione della compensazione";

          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail,
            life: 4000,
          });
        }
      } catch (error) {
        console.error("Errore durante la cancellazione della compensazione:", error);
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante la cancellazione della compensazione",
          life: 4000,
        });
      } finally {
        this.loader = false;
        this.selectedPayment = null;
      }
    },
  },
};
</script>

<style scoped>
.agyo .stato {
  font-size: 14px;
  color: rgb(189, 189, 189);
}

.agyo .data {
  font-size: 14px;
  color: rgb(189, 189, 189);
}
.agyo .source {
  font-size: 10px;
  margin-top: 12px;
  color: rgb(189, 189, 189);
}

.stati-posta-list {
  margin: 8px 0 0;
  padding-left: 18px;
}

.stato-servizio {
  font-weight: 600;
}

.sposta-credito-info p {
  margin: 0 0 0.5rem;
}

.sposta-credito-saldo {
  border-left: 1px solid #d1d5db;
  padding-left: 2rem;
  margin-left: 2rem;
  min-width: 140px;
  text-align: right;
}

.pagamenti-toolbar {
  padding: 0 0.25rem;
}

.pagamenti-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.richiedi-rimborso-button-wrapper {
  display: inline-flex;
}

.email-log-link {
  cursor: pointer;
  text-decoration: underline;
}

.richiedi-rimborso-dialog {
  position: relative;
}

.richiedi-rimborso-dialog--loading {
  min-height: 220px;
}

.richiedi-rimborso-dialog-loader {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  background: rgba(255, 255, 255, 0.9);
}

.richiedi-rimborso-dialog-loader-text {
  color: var(--text-color-secondary);
  font-weight: 600;
}

.richiedi-rimborso-dialog-content--hidden {
  visibility: hidden;
}

.required-mark {
  color: var(--red-500, #ef4444);
}
</style>

